import RouteNames from '@/constants/route-names';

import ClientLayout from '@/client/client.layout.vue';
import BudgetAcceptance from '@/client/budget/views/acceptance/index.vue';
import AcceptanceValidation from '@/client/budget/views/acceptance/validation/index.vue';
import MandateSignature from '@/client/budget/views/mandate-signature/index.vue';
import MyIdLogin from '@/client/budget/views/acceptance/login-dni/index.vue';

const ClientRouter = {
  path: '/client/',
  component: ClientLayout,
  name: 'client',
  children: [{
    path: 'budget/:id/acceptance/:step?/',
    name: RouteNames.BudgetAcceptance,
    props: true,
    component: BudgetAcceptance,
  }, {
    path: 'budget/:id/validation/',
    name: RouteNames.BudgetAcceptanceValidation,
    props: true,
    component: AcceptanceValidation,
  }, {
    path: 'budget/:id/mandate/',
    name: RouteNames.BudgetMandateSignature,
    props: true,
    component: MandateSignature,
  }, {
    path: 'budget/portal/:dni?/',
    name: RouteNames.BudgetLoginDni,
    props: true,
    component: MyIdLogin,
  }],
};

export default [
    ClientRouter,
];
